import "react-toastify/dist/ReactToastify.css";
import "@szhsin/react-menu/dist/index.css";
import "@szhsin/react-menu/dist/transitions/zoom.css";

import "./localization/i18n";
import "./assets/js/libs/smoothy/smoothy";

import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";

import App from "./App";
import { ThemeProvider } from "./context/ThemeContext";
import store from "./redux/store";

const originalConsoleError = console.error;

console.error = (...args) => {
  const [firstArg] = args;
  if (typeof firstArg === "string" && firstArg.includes("validateDOMNesting")) {
    return; // Skip this warning
  }
  originalConsoleError(...args);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ThemeProvider>
    <Provider store={store}>
      <App />

      <ToastContainer
        containerId="simple"
        position="top-center"
        pauseOnHover
        theme="colored"
        autoClose={2000}
        limit={1}
      />

      <ToastContainer
        containerId="notification"
        position="top-right"
        autoClose={3000}
        hideProgressBar
        closeButton={false}
        draggable
        pauseOnHover
        newestOnTop
        theme="light"
      />
    </Provider>
  </ThemeProvider>
);
